import { ts, ts2 } from "src/utils/translate";
import { GetProductsOfRoomsByFloorsFloor } from "src/model/api/v2/data-contracts";
import { useDeleteFloorMutation } from "src/api/v2/floor-v2-ApiSlice";
import { BaseDialog } from "src/components/BaseDialog/BaseDialog";
import { useAppDispatch, useAppSelector } from "src/app/hooks";
import { plannerUiSlice } from "src/api/planner-ui-slice";
import { showSnackBar } from "src/api/ui-slice";

interface DeleteFloorDialogProps {
  onClose: () => void,
  floor: GetProductsOfRoomsByFloorsFloor | null
}

export const DeleteFloorDialog = ({onClose, floor}: DeleteFloorDialogProps) => {
  const [deleteFloor] = useDeleteFloorMutation();
  const dispatch = useAppDispatch();
  const selectedFloorId = useAppSelector((state) => state.plannerUi.selectedFloorId);

  const handleDeleteFloor = () => {
    if (!floor?.floor_id) return;
    if (selectedFloorId === floor.floor_id) {
      dispatch(plannerUiSlice.actions.setSelectedFloorId(null));
    }

    deleteFloor(floor.floor_id)
      .unwrap()
      .then(() => onClose())
      .catch(() => {
        dispatch(showSnackBar({ text: ts('delete_floor_error', 'Failed to delete floor'), severity: 'error' }));
      });
  };

  return (
      <BaseDialog
          onClose={onClose}
          title={ts('planner_floor_deletion_dialog_title', "Delete Floor?")}
          cancelLabel={ts("planner_deletion_dialog_cancel_button_text", "Cancel")}
          actionLabel={ts("planner_deletion_dialog_action_button_text", "Delete")}
          onAction={handleDeleteFloor}
      >
        {ts2('planner_floor_deletion_dialog_content', "Are you sure you want to delete the {floorName} floor?", {
          floorName: floor?.floor_name ?? ''
        })}
      </BaseDialog>
  )
}